
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/imovel/[slug]",
      function () {
        return require("private-next-pages/imovel/[slug].js");
      }
    ]);
  